/* eslint-disable import/no-anonymous-default-export */
import React from 'react'
import StatusTable from '../StatusTable'

export default () => {
  const tableData = (item, tableHeadings) => {
    let tempData = []
    tableHeadings &&
      tableHeadings.map((val) => {
        let status = val === 'status' ? { type: 'STATUS_ENUM', status: item[val] } : { value: item[val] }
        tempData.push(status)
      })
    return tempData
  }

  return <StatusTable tableData={tableData} module="SFTP" />
}
